module.exports = ".mobPad0 {\n  padding: 0px; }\n\n.d-InlineBlock {\n  display: inline-block; }\n"